export const ChannelDisconnectionEvent = {
  BANNER_SHOWN: 'CHANNEL_DISCONNECTION.BANNER.SHOWN',
  MODAL_SHOWN: 'CHANNEL_DISCONNECTION.MODAL.SHOWN',
  MODAL_CTA_CLICKED: 'CHANNEL_DISCONNECTION.MODAL.CTA_CLICKED',
  MODAL_DISMISSED: 'CHANNEL_DISCONNECTION.MODAL.DISMISSED',
} as const
